import type { InquiryAssignResponse } from 'backend/types'
import type { WorkLocations } from 'shared'

/**
 * 契約形態（社員/BP）
 * TODO: DB移行後にinquiry_assignsテーブルにcontract_typeカラムを追加し、APIから取得する
 */
export type ContractTypes = {
  employee: boolean
  bp: boolean
}

/**
 * フロントエンド拡張のアサイン型
 * InquiryAssignResponse に契約形態のフロントエンド専用フィールドを追加
 *
 * TODO: contract_types の DB移行・API対応後はInquiryAssignResponseに統合する
 */
export type InquiryAssignLocal = InquiryAssignResponse & {
  contract_types: ContractTypes
  work_locations: WorkLocations
}

export const DEFAULT_CONTRACT_TYPES: ContractTypes = {
  employee: false,
  bp: false,
}
